(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('.bv-video').forEach(video => {
      if (video.dataset.bvReady) return;
      video.dataset.bvReady = 'true';
      video.muted = true;
      let userPaused = false;
      let internalChange = false;
      video.addEventListener('pause', () => { if (!internalChange) userPaused = true; });
      video.addEventListener('play', () => { userPaused = false; });
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !motionQuery.matches && !userPaused && !document.hidden) {
            video.play().catch(() => {});
          } else if (!video.paused) {
            internalChange = true;
            video.pause();
            setTimeout(() => { internalChange = false; }, 100);
          }
        });
      }, { threshold: .35 });
      observer.observe(video);
      observers.set(video, observer);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.bv-video').forEach(video => observers.get(video)?.disconnect());
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('.bv-video').forEach(video => video.pause());
  });
  motionQuery.addEventListener('change', () => {
    if (motionQuery.matches) document.querySelectorAll('.bv-video').forEach(video => video.pause());
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bv-header details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
})();
